import { useApolloClient, useMutation } from '@apollo/react-hooks';
import {
  AdminEditUser,
  AdminEditUserVariables,
} from '../../graphql/user/types/AdminEditUser';
import { ADMIN_EDIT_USER } from '../../graphql/user/mutation';
import { displaySnackBar } from '../../common/displaySnackbar';
const useLogic = () => {
  const client = useApolloClient();
  const [editUser, { loading }] = useMutation<
    AdminEditUser,
    AdminEditUserVariables
  >(ADMIN_EDIT_USER, {
    onCompleted: () => {
      displaySnackBar(client, {
        type: 'SUCCESS',
        message: 'Utilisateur effacé avec succès',
        isOpen: true,
      });
    },
    onError: (error) => {
      displaySnackBar(client, {
        type: 'ERROR',
        message: 'Erreur de suppression.',
        isOpen: true,
      });
    },
  });
  return { editUser, loading };
};
export default useLogic;
